import { render, staticRenderFns } from "./ExpandableItem.vue?vue&type=template&id=5e5ef849&scoped=true&"
import script from "./ExpandableItem.vue?vue&type=script&lang=js&"
export * from "./ExpandableItem.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableItem.vue?vue&type=style&index=0&id=5e5ef849&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5ef849",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
